<template>
  <v-dialog v-model="show" max-width="480" persistent>
    <v-card>
      <v-card-title>{{ $t("finance_new_platform_payment") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <text-field
            v-model.number="form.amount"
            :label="$t('finance_amount_currency', { currency: restaurantCurrency })"
            type="number"
            :suffix="restaurantCurrency"
            :rules="[rules.required, rules.positive]"
          />
          <payment-method-dropdown v-model="form.method" :rules="[rules.required]" />
          <text-field
            v-model="form.period"
            :label="$t('finance_period_label')"
            prependInnerIcon="mdi-calendar-range-outline"
          />
          <text-area v-model="form.note" :label="$t('finance_comment_optional')" rows="2" />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PaymentMethodDropdown from "../fields/PaymentMethodDropdown.vue";

const emptyForm = () => ({ amount: 0, period: "", note: "", method: "" });

// Isti obrazac kao PayoutFormDialog.vue - vidi komentar tamo. Backend odgovor
// 16.09.2026 §2.
const generateIdempotencyKey = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export default {
  name: "PlatformPaymentFormDialog",

  components: { PaymentMethodDropdown },

  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },

  data() {
    return {
      valid: true,
      form: emptyForm(),
      idempotencyKey: "",
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
        positive: (v) => Number(v) > 0 || this.$t("finance_amount_must_be_positive"),
      },
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      this.form = emptyForm();
      this.idempotencyKey = generateIdempotencyKey();
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", {
        amount: Number(this.form.amount),
        method: this.form.method,
        period: this.form.period || undefined,
        note: this.form.note || undefined,
        idempotency_key: this.idempotencyKey,
      });
    },
  },
};
</script>
